import classnames from 'classnames';

import {
  benefitsCode,
  cardsBannerCode,
  landingSkinnyBannerCode,
  selfcareSkinnyBannerCode,
  supportBannerCode,
  hubBannerCode,
  heroBannerTypeACode,
  heroBannerTypeBCode,
  heroBannerTypeCCode,
  heroBannerTypeDCode,
  heroBannerTypeECode,
  testimonialsBannerCode,
  carouselBannerCode,
  articlesBannerCode,
  advantagesBannerCode,
  newsBannerCode,
  mediaBannerCode
} from './bannersCode';

import {
  benefitsBannerLayout,
  cardsBannerLayout,
  landingSkinnyBannerLayout,
  selfcareSkinnyBannerLayout,
  supportBannerLayout,
  hubBannerLayout,
  heroBannerTypeALayout,
  heroBannerTypeBLayout,
  heroBannerTypeCLayout,
  heroBannerTypeDLayout,
  heroBannerTypeELayout,
  testimonialsBannerLayout,
  carouselBannerLayout,
  articlesBannerLayout,
  advantagesBannerLayout,
  newsBannerLayout,
  mediaBannerLayout
} from './bannersLayouts';

import styles from '../Banners.css';

export const bannersSet = [
  {
    type: 'benefits',
    previews: [
      {
        component: benefitsBannerLayout,
        codeTemplate: benefitsCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.benefitsBannerPreview, 'bannerImage'),
        optionsGroup: [
          { label: 'Type A', options: [
              {label: 'Version 1', type: 'radio', options: {bgColor: 'heavy-blue', version: 1, imagePath: 'banners/benefits1.png', __key: 'version1'}},
              {label: 'Version 2', type: 'radio', options: {version: 2, imagePath: 'banners/benefits2.png', __key: 'version2'}},
            ]
          }
        ],
      },
    ]
  },
  {
    type: 'cards',
    previews: [
      {
        component: cardsBannerLayout,
        codeTemplate: cardsBannerCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.cardsBannerPreview, 'bannerImage'),
        optionsGroup: [
          { label: 'Type A', options: [
              {label: 'Version 1', type: 'radio', options: { version: 1, imagePath: 'banners/cards1.png' }},
              {label: 'Version 2', type: 'radio', options: { version: 2, imagePath: 'banners/cards2.png' }},
            ]
          }
        ],
      },
    ]
  },
  {
    type: 'skinny',
    previews: [
      {
        component: landingSkinnyBannerLayout,
        codeTemplate: landingSkinnyBannerCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.skinnyBannerPreview, 'bannerImage'),
        optionsGroup: [
          { label: 'Landings', options: [
              {label: 'Type A', type: 'radio', options: { bgColor: 'heavy-blue', version: 1, imagePath: 'banners/skinnyLanding1.png' }},
              {label: 'Type B', type: 'radio', options: { bgColor: 'heavy-blue', version: 2, imagePath: 'banners/skinnyLanding2.png' }},
            ]
          }
        ],
      },
      {
        component: selfcareSkinnyBannerLayout,
        codeTemplate: selfcareSkinnyBannerCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.skinnyBannerSelfcarePreview, 'bannerImage'),
        optionsGroup: [
          { label: 'Selfcare', options: [
              {label: 'Type A', type: 'radio', options: { bgColor: 'heavy-blue', version: 1, imagePath: 'banners/skinnySelfcare1.png' }},
            ]
          }
        ],
      },
    ]
  },
  {
    type: 'support',
    previews: [
      {
        component: supportBannerLayout,
        codeTemplate: supportBannerCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.supportLandingPreview, 'bannerImage'),
        optionsGroup: [
          { label: 'Landings', options: [
              {label: 'Type A', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'banners/supportLanding.png' }},
            ]
          }
        ],
      },
    ]
  },
  {
    type: 'hub',
    previews: [
      {
        component: hubBannerLayout,
        codeTemplate: hubBannerCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.hubBannerPreview, 'bannerImage'),
        optionsGroup: [
          { label: 'Landings', options: [
              {label: 'Type A', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'banners/hub1.png' }},
            ]
          }
        ],
      },
    ]
  },
  {
    type: 'hero',
    previews: [
      {
        component: heroBannerTypeALayout,
        codeTemplate: heroBannerTypeACode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.heroABannerPreview, 'bannerImage'),
        optionsGroup: [
          { label: 'Type A', options: [
              {label: 'Version 1', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'banners/hero/typeA1.png', version: 1 }},
              {label: 'Version 2', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'banners/hero/typeA2.png', version: 2 }},
              {label: 'Version 3', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'banners/hero/typeA3.png', version: 3 }},
              {label: 'Version 4', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'banners/hero/typeA4.png', version: 4 }},
            ]
          }
        ],
      },
      {
        component: heroBannerTypeBLayout,
        codeTemplate: heroBannerTypeBCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.heroBBannerPreview, 'bannerImage'),
        optionsGroup: [
          { label: 'Type B', options: [
              {label: 'Version 1', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'banners/hero/typeB1.png', version: 1 }},
              {label: 'Version 2', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'banners/hero/typeB2.png', version: 2 }},
            ]
          }
        ],
      },
      {
        component: heroBannerTypeCLayout,
        codeTemplate: heroBannerTypeCCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.heroCBannerPreview, 'bannerImage'),
        optionsGroup: [
          { label: 'Type C', options: [
              {label: 'Version 1', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'banners/hero/typeC.png' }},
            ]
          }
        ],
      },
      {
        component: heroBannerTypeDLayout,
        codeTemplate: heroBannerTypeDCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.heroDBannerPreview, 'bannerImage'),
        optionsGroup: [
          { label: 'Type D', options: [
              {label: 'Version 1', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'banners/hero/typeD.png' }},
            ]
          }
        ],
      },
      {
        component: heroBannerTypeELayout,
        codeTemplate: heroBannerTypeECode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.heroEBannerPreview, 'bannerImage'),
        optionsGroup: [
          { label: 'Type E', options: [
              {label: 'Version 1', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'banners/hero/typeE.png' }},
            ]
          }
        ],
      },
    ]
  },
  {
    type: 'others',
    previews: [
      {
        component: testimonialsBannerLayout,
        codeTemplate: testimonialsBannerCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.testimonialsBannerLayout, 'bannerImage'),
        optionsGroup: [
          { label: 'Testimonials', options: [
              {label: 'Type A', type: 'radio', options: { imagePath: 'banners/others/testimonials.png' }},
            ]
          }
        ],
      },
      {
        component: carouselBannerLayout,
        codeTemplate: carouselBannerCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.carouselBannerLayout, 'bannerImage'),
        optionsGroup: [
          { label: 'Carousel', options: [
              {label: 'Type A', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'banners/others/carousel1.png', version: 1 }},
              {label: 'Type B', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'banners/others/carousel2.png', version: 2 }},
            ]
          }
        ],
      },
      {
        component: articlesBannerLayout,
        codeTemplate: articlesBannerCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.articlesBannerLayout, 'bannerImage'),
        optionsGroup: [
          { label: 'Articles', options: [
              {label: 'Type A', type: 'radio', options: { imagePath: 'banners/others/articles1.png', version: 1 }},
              {label: 'Type B', type: 'radio', options: { imagePath: 'banners/others/articles2.png', version: 2 }}
            ]
          }
        ],
      },
      {
        component: advantagesBannerLayout,
        codeTemplate: advantagesBannerCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.advantagesBannerLayout, 'bannerImage'),
        optionsGroup: [
          { label: 'Advantages', options: [
              {label: 'Type A', type: 'radio', options: { imagePath: 'banners/others/advantages.png' }},
            ]
          }
        ],
      },
      {
        component: newsBannerLayout,
        codeTemplate: newsBannerCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.newsBannerLayout, 'bannerImage'),
        optionsGroup: [
          { label: 'News', options: [
              {label: 'Type A', type: 'radio', options: { imagePath: 'banners/others/news.png' }},
            ]
          }
        ],
      },
      {
        component: mediaBannerLayout,
        codeTemplate: mediaBannerCode,
        modalPreviewClassName: 'with-padding',
        previewClassName: classnames(styles.mediaBannerLayout, 'bannerImage'),
        optionsGroup: [
          { label: 'Media', options: [
              {label: 'Type A', type: 'radio', options: { imagePath: 'banners/others/media1.png', version: 1 }},
              {label: 'Type B', type: 'radio', options: { imagePath: 'banners/others/media2.png', version: 2 }},
            ]
          }
        ],
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/containers/components/Banner/constants/bannersSet.js